<a
  [addAaTags]="'Skip to main content'"
  class="skip-to-main-content-link"
  href="#main"
  (click)="skipToMain($event)"
  (keydown.enter)="skipToMain($event)"
  (keydown.space)="skipToMain($event)"
  tabindex="-1"
  >Skip to Main Content
</a>
<app-header *ngIf="!hideSideBar"></app-header>
<app-sidebar>
  <router-outlet></router-outlet>
</app-sidebar>
<div *ngIf="!hideSideBar" class="mb-2"></div>
<div id="recaptcha-container-id" style="opacity: 0"></div>
